<template>
	<div>
		<div class="modal fade" :class="{show: show}" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">{{ textTitle }}</h5>
					</div>
					<div class="modal-body" v-html="textMessage"></div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" @click="cancelHandler">{{ textCancel }}</button>
						<button type="button" class="btn btn-primary" @click="confirmHandler">{{ textOk }}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-backdrop fade" :class="{show: show}"></div>
	</div>
</template>
<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		textTitle: {
			type: String,
			default: 'Подтвердите действие'
		},
		textMessage: {
			type: String,
			default: 'Это действие нельзя будет отменить!'
		},
		textCancel: {
			type: String,
			default: 'Нет'
		},
		textOk: {
			type: String,
			default: 'Да'
		}
	},
	created () {
		document.body.classList.add('modal-open')
	},
	methods: {
		cancelHandler () {
			document.body.classList.remove('modal-open')
			this.$emit('cancel')
		},
		confirmHandler () {
			document.body.classList.remove('modal-open')
			this.$emit('confirm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ui/dialog/Confirm.vue